export default {

  todaysEodReviewPreview(state) {
    return state.todaysEodReviewPreview;
  },
  todaysJournal(state) {
    return state.todaysJournal;
  },

};
